































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class StepText extends Vue {

  @Prop({default: true})
  visible: boolean;
  @Prop({default: []})
  styleList: Array<any>;
  @Prop({default: ''})
  currNameEN: string;

  show = false;

  @Watch('visible', { immediate: true })
  listenVisible(val) {
    this.show = val;
  }
  // 关闭弹窗
  closePopup() {
    this.show = false;
    this.$emit('close');
  }

  // 选中
  doCheckItem(item) {
    this.$emit('change', item);
    this.closePopup();
  }

}
